module.exports = __webpack_public_path__ + "img/g10.35b2cf64.jpg";